import localforage from "localforage";
import Config from "@app/constants/Config";
import { authMiddleware } from "@app/utils/helper";

const store = localforage.createInstance({
	name: "settings",
});

export async function setSetting(key, value) {
	return store.setItem(key, value);
}

export async function getSetting(key) {
	return await store.getItem(key);
}

export async function clearSettings() {
	return store.clear();
}

async function loadUserProfile() {
	const response = await fetch(Config.API.USER.LOAD, {
		credentials: "include",
	});
	return response.json();
}

export async function setUserProfile() {
	const userProfile = await loadUserProfile();
	await setSetting("user", userProfile.user);
}

export async function getUserProfile() {
	const user = await getSetting("user");
	if (!user) {
		const userProfile = await loadUserProfile();
		await setSetting("user", userProfile.user);
		return userProfile;
	} else {
		return user;
	}
}
